export enum Keys {
  ENTER = "Enter",
  BACKSPACE = "Backspace",
}
